//variance
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import Layout from "../../Component/Layout";
import Select from "react-select";
import { PURCHASE_API, MASTER_API } from "../../apiConfig";

const styles = {
    pageTitleBar: {
        marginBottom: "20px"
    },

    pageTitle: {
        fontSize: "28px",
        fontWeight: "600",
        color: "#0f172a",
        marginBottom: "4px"
    },

    pageSubtitle: {
        color: "#64748b",
        fontSize: "14px"
    },

    filterCard: {
        background: "#fff",
        borderRadius: "8px",
        padding: "15px",
        boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
        marginBottom: "15px"
    },

    compactLabel: {
        fontSize: "12px",
        fontWeight: "600",
        color: "#334155",
        marginBottom: "4px",
        display: "block"
    },

    dateInput: {
        width: "100%",
        height: "38px",
        padding: "6px 10px",
        fontSize: "13px",
        color: "#0f172a",
        border: "1px solid #cbd5e1",
        borderRadius: "6px",
        boxSizing: "border-box"
    },

    exportBtn: {
        background: "#16a34a",
        color: "#fff",
        border: "none",
        borderRadius: "6px",
        padding: "8px 16px",
        fontSize: "13px",
        fontWeight: "600",
        cursor: "pointer"
    },

    exportBtnDisabled: {
        background: "#94a3b8",
        color: "#fff",
        border: "none",
        borderRadius: "6px",
        padding: "8px 16px",
        fontSize: "13px",
        fontWeight: "600",
        cursor: "not-allowed"
    },

    tableContainer: {
        background: "#fff",
        borderRadius: "12px",
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        padding: "10px",
        border: "1px solid #e2e8f0",
        borderBottom: "none",
        overflowX: "auto"
    },

    erpTable: {
        marginBottom: 0,
        fontSize: "13px"
    },

    erpTh: {
        background: "#ffffff",
        color: "#0f172a",
        fontWeight: "600",
        padding: "12px",
        borderBottom: "1px solid #e2e8f0",
        whiteSpace: "nowrap"
    },

    erpTd: {
        padding: "10px 12px",
        borderBottom: "1px solid #f1f5f9",
        whiteSpace: "nowrap",
        color: "#334155"
    },

    cellLink: {
        color: "#2563eb",
        textDecoration: "none",
        fontWeight: 600,
        cursor: "pointer"
    },

    paginationBar: {
        background: "#fff",
        borderRadius: "12px",
        padding: "14px 20px",
        border: "1px solid #e2e8f0",
        borderTop: "none",
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
    },

    paginationInfo: {
        fontSize: "13px",
        color: "#334155"
    },

    paginationButtons: {
        display: "flex",
        gap: "8px"
    },

    paginationBtn: {
        padding: "6px 16px",
        fontSize: "13px",
        fontWeight: "600",
        borderRadius: "6px",
        border: "1px solid #e2e8f0",
        background: "#fff",
        color: "#334155",
        cursor: "pointer"
    },

    paginationBtnDisabled: {
        padding: "6px 16px",
        fontSize: "13px",
        fontWeight: "600",
        borderRadius: "6px",
        border: "1px solid #e2e8f0",
        background: "#f8fafc",
        color: "#cbd5e1",
        cursor: "not-allowed"
    },

    pageSizeSelect: {
        padding: "6px 10px",
        fontSize: "13px",
        fontWeight: "600",
        borderRadius: "6px",
        border: "1px solid #e2e8f0",
        background: "#fff",
        color: "#334155",
        cursor: "pointer",
        outline: "none"
    }
};

// Strips unnecessary trailing decimal zeros from a qty value coming back
// from the DB as a fixed-precision string (e.g. "100.00" -> "100",
// "25.50" -> "25.5"). Leaves non-numeric / empty values as-is.
const formatQty = (qty) => {
    if (qty === null || qty === undefined || qty === "") return qty;
    const num = Number(qty);
    if (Number.isNaN(num)) return qty;
    return num.toLocaleString("en-IN", { maximumFractionDigits: 2 });
};

// dd-mm-yyyy for display
const formatDate = (value) => {
    if (!value) return "-";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return "-";
    return `${String(d.getDate()).padStart(2, "0")}-${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`;
};

// 1,234.50 style amount (always 2 decimals)
const formatAmount = (v) => {
    if (v === null || v === undefined || v === "") return "-";
    const n = Number(v);
    if (Number.isNaN(n)) return "-";
    return n.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const modalStyles = {
    overlay: { position: "fixed", inset: 0, background: "rgba(15,23,42,0.55)", zIndex: 2000, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 },
    modal: { background: "#fff", borderRadius: 12, width: "100%", maxWidth: 1300, maxHeight: "92vh", display: "flex", flexDirection: "column", boxShadow: "0 10px 40px rgba(0,0,0,0.25)" },
    header: { padding: "16px 20px", borderBottom: "1px solid #e2e8f0" },
    summary: { display: "flex", gap: 10, flexWrap: "wrap", padding: "12px 20px", borderBottom: "1px solid #f1f5f9" },
    chip: { background: "#f1f5f9", color: "#334155", borderRadius: 999, padding: "4px 12px", fontSize: 12, fontWeight: 600 },
    body: { overflow: "auto", padding: "0 20px", flex: 1 },
    th: { position: "sticky", top: 0, background: "#fff", padding: "10px 10px", fontSize: 12, fontWeight: 600, color: "#0f172a", borderBottom: "1px solid #e2e8f0", whiteSpace: "nowrap", zIndex: 1 },
    td: { padding: "8px 10px", fontSize: 12, color: "#334155", borderBottom: "1px solid #f1f5f9", whiteSpace: "nowrap" },
    footer: { padding: "14px 20px", borderTop: "1px solid #e2e8f0", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12 }
};

const renderChange = (oldVal, newVal) =>
    oldVal === newVal || !newVal
        ? (oldVal || "-")
        : !oldVal
            ? <strong style={{ color: "#0f172a" }}>{newVal}</strong>
            : <span><span style={{ color: "#94a3b8", textDecoration: "line-through" }}>{oldVal}</span> → <strong style={{ color: "#0f172a" }}>{newVal}</strong></span>;

// List status is either Posted (every batch posted) or Pending (anything still to post,
// including partially posted physical inventories).
const STATUS_CHIP = {
    PENDING: { label: "Pending", bg: "#fef3c7", color: "#92400e" },
    PARTIAL: { label: "Pending", bg: "#fef3c7", color: "#92400e" },
    UPDATED: { label: "Posted", bg: "#dcfce7", color: "#166534" }
};

// Variance colouring (same idea as the stock report): red when the counted
// stock is LESS than system stock, green when it is MORE, neutral when equal.
const varianceTone = (variance) => {
    const v = Number(variance) || 0;
    if (v < 0) return { color: "#b91c1c", bg: "#fee2e2" };
    if (v > 0) return { color: "#15803d", bg: "#dcfce7" };
    return { color: "#94a3b8", bg: "transparent" };
};

const PAGE_SIZE_OPTIONS = [10, 15, 20, 25, 30, 40, 50];

// ── Styles for the Construction..Voltage cable-attribute filter row (matches Production Order) ──
const cableFilterSelectStyles = {
    control: (base, state) => ({ ...base, minHeight: 32, height: 32, fontSize: 12, borderColor: state.isFocused ? "#64748b" : "#e2e8f0", borderRadius: 6, boxShadow: "none", cursor: "pointer", "&:hover": { borderColor: "#94a3b8" } }),
    valueContainer: (base) => ({ ...base, padding: "0 8px", height: 32, flexWrap: "nowrap" }),
    input: (base) => ({ ...base, margin: 0, padding: 0, fontSize: 12 }),
    indicatorsContainer: (base) => ({ ...base, height: 32 }),
    dropdownIndicator: (base) => ({ ...base, padding: "0 4px", color: "#94a3b8", svg: { width: 12, height: 12 } }),
    clearIndicator: (base) => ({ ...base, padding: "0 2px", color: "#94a3b8", svg: { width: 12, height: 12 } }),
    indicatorSeparator: () => ({ display: "none" }),
    placeholder: (base) => ({ ...base, color: "#94a3b8", fontSize: 12, whiteSpace: "nowrap" }),
    singleValue: (base) => ({ ...base, fontSize: 12, color: "#1e293b" }),
    menu: (base) => ({ ...base, zIndex: 9999, fontSize: 12, borderRadius: 6, boxShadow: "0 4px 12px rgba(0,0,0,0.12)" }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (base, state) => ({ ...base, fontSize: 12, padding: "6px 10px", backgroundColor: state.isSelected ? "#1e293b" : state.isFocused ? "#f1f5f9" : "#fff", color: state.isSelected ? "#fff" : "#334155" }),
};

const selectStyles = {
    control: (provided) => ({
        ...provided,
        minHeight: "34px",
        height: "34px",
        fontSize: "12px"
    }),
    valueContainer: (provided) => ({
        ...provided,
        height: "34px",
        padding: "0 8px"
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        height: "34px"
    }),
    option: (provided) => ({
        ...provided,
        fontSize: "12px"
    }),
    singleValue: (provided) => ({
        ...provided,
        fontSize: "12px"
    }),
    placeholder: (provided) => ({
        ...provided,
        fontSize: "12px"
    })
};

const Variance = () => {
    const [tableData, setTableData] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [dateFromText, setDateFromText] = useState("");
    const [dateToText, setDateToText] = useState("");
    const [pageSize, setPageSize] = useState(10);

    // ── Physical inventory detail modal ──
    const [detail, setDetail] = useState(null);          // response of /variance/detail
    const [selected, setSelected] = useState([]);        // selected line ids (pending only)
    const [detailLoading, setDetailLoading] = useState(null);
    const [applying, setApplying] = useState(false);

    // ── Toast ──
    const [toast, setToast] = useState(null);
    const toastTimer = useRef(null);
    const showToast = (message, type = "error") => {
        if (toastTimer.current) clearTimeout(toastTimer.current);
        setToast({ message, type });
        toastTimer.current = setTimeout(() => setToast(null), type === "success" ? 5000 : 7000);
    };
    useEffect(() => () => toastTimer.current && clearTimeout(toastTimer.current), []);
    const TOAST_COLORS = {
        success: { bg: "#ecfdf5", border: "#10b981", text: "#065f46", icon: "✓" },
        error: { bg: "#fef2f2", border: "#ef4444", text: "#991b1b", icon: "✕" },
        warning: { bg: "#fffbeb", border: "#f59e0b", text: "#92400e", icon: "!" }
    };


    const [productTypes, setProductTypes] = useState([]);
    const [allProductCodeOptions, setAllProductCodeOptions] = useState([]);
    const [batchNumberOptions, setBatchNumberOptions] = useState([]);
    const [storageLocationOptions, setStorageLocationOptions] = useState([]);

    // Shared product master list used to make the filters cascade together
    const [products, setProducts] = useState([]);

    const [filters, setFilters] = useState({
        productType: null,
        productCode: null,
        batchNumber: null,
        storageLocation: null,
        construction: null,
        code: null,
        cableType: null,
        category: null,
        noOfCores: null,
        color: null,
        nominalCrossSection: null,
        referenceOfStandard: null,
        voltage: null,
        subCategory: null,
        qualityCategory: null,
        dateFrom: "",
        dateTo: ""
    });

    useEffect(() => {
        loadFilterOptions();
        loadProducts();
    }, []);

    useEffect(() => {
        fetchInventory();
        setCurrentPage(1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters]);

    const loadFilterOptions = async () => {
        try {

            const [
                productTypesRes,
                productCodesRes,
                batchNumbersRes,
                storageLocationsRes
            ] = await Promise.all([
                axios.get(`${MASTER_API}/configuration/product-types`),
                axios.get(`${PURCHASE_API}/batch-list/product-codes`),
                axios.get(`${PURCHASE_API}/batch-list/batch-numbers`),
                axios.get(`${PURCHASE_API}/batch-list/storage-locations`)
            ]);

            // ── Product Type options come from the configuration master list ──
            // ── (Configuration → Master Data → Product Type) rather than distinct ──
            // ── values off batch records, so every configured type shows up and ──
            // ── inconsistent casing/duplicates from raw data are avoided. ──
            setProductTypes(
                (productTypesRes.data || []).map((r) => {
                    const val = String(r.name || r.productType || "").trim();
                    return { value: val, label: val };
                }).filter((o) => o.value !== "")
            );

            setAllProductCodeOptions(
                (productCodesRes.data.data || []).map((r) => ({
                    value: r.productCode,
                    label: r.productDescription
                        ? `${r.productCode} - ${r.productDescription}`
                        : r.productCode
                }))
            );

            setBatchNumberOptions(
                (batchNumbersRes.data.data || []).map((r) => ({
                    value: r.batch_number,
                    label: r.batch_number
                }))
            );

            setStorageLocationOptions(
                (storageLocationsRes.data.data || []).map((r) => ({
                    value: r.storage_code,
                    label: `${r.storage_code} - ${r.storage_location}`
                }))
            );

        } catch (err) {
            console.error(err);
        }
    };

    const loadProducts = () => {
        axios.get(`${MASTER_API}/bom/products`)
            .then((res) => setProducts(res.data.data || []))
            .catch((err) => console.error("Failed loading products for Stock Report filters", err.response?.data || err.message));
    };

    const ATTRIBUTE_FILTER_KEYS = [
        "productType", "construction", "code", "cableType", "category",
        "noOfCores", "color", "nominalCrossSection", "referenceOfStandard",
        "voltage", "subCategory", "qualityCategory", "productCode"
    ];

    // Only filters by a key if that field is actually present on the product
    // records — this prevents a missing/renamed backend column from silently
    // zeroing out all results.
    const productKeys = products.length > 0 ? Object.keys(products[0]) : [];

    const productMatchesFilterSet = (p, filterSet, excludeKey) =>
        Object.entries(filterSet).every(([key, val]) => {
            if (key === excludeKey) return true;
            if (!ATTRIBUTE_FILTER_KEYS.includes(key)) return true;
            if (!val) return true;
            if (!productKeys.includes(key)) return true;
            const productVal = String(p[key] || "").trim().toLowerCase();
            const filterVal = String(val.value || "").trim().toLowerCase();
            return productVal === filterVal;
        });

    // ── Cascading options for a given filter field: computed from products that
    // match every OTHER active filter (so a field's own current selection never
    // hides its sibling options), restricted to values that actually appear in
    // the data. Mirrors BOM's getCascadingOptions exactly. ──
    const getCascadingOptions = (key) => {
        if (!productKeys.includes(key)) return [];
        const relevant = products.filter((p) => productMatchesFilterSet(p, filters, key));
        const uniqueVals = Array.from(
            new Set(
                relevant
                    .map((p) => p[key])
                    .filter((v) => v !== undefined && v !== null && v !== "")
                    .map((v) => String(v).trim())
                    .filter((v) => v !== "")
            )
        );
        return uniqueVals
            .map((v) => ({ value: v, label: v }))
            .sort((a, b) => a.label.localeCompare(b.label));
    };

    // Product Code options are further restricted to codes that actually have
    // stock (allProductCodeOptions, from batch-list/product-codes), and use that
    // list's "CODE - Description" label instead of the bare code.
    const productCodeLabelMap = new Map(allProductCodeOptions.map((o) => [o.value, o.label]));
    const cascadingProductCodeOptions = getCascadingOptions("productCode")
        .filter((o) => productCodeLabelMap.has(o.value))
        .map((o) => ({ value: o.value, label: productCodeLabelMap.get(o.value) }));

    const fetchInventory = async () => {
        try {

            const res = await axios.post(
                `${PURCHASE_API}/physical-inventory/variance/list`,
                {
                    productType: filters.productType?.value || "",
                    productCode: filters.productCode?.value || "",
                    batchNumber: filters.batchNumber?.value || "",
                    storageCode: filters.storageLocation?.value || "",
                    construction: filters.construction?.value || "",
                    code: filters.code?.value || "",
                    cableType: filters.cableType?.value || "",
                    category: filters.category?.value || "",
                    noOfCores: filters.noOfCores?.value || "",
                    color: filters.color?.value || "",
                    nominalCrossSection: filters.nominalCrossSection?.value || "",
                    referenceOfStandard: filters.referenceOfStandard?.value || "",
                    voltage: filters.voltage?.value || "",
                    subCategory: filters.subCategory?.value || "",
                    qualityCategory: filters.qualityCategory?.value || "",
                    dateFrom: filters.dateFrom || "",
                    dateTo: filters.dateTo || ""
                }
            );

            setTableData(res.data.data || []);

        } catch (err) {
            console.error(err);
        }
    };

    const openDetail = async (importId) => {
        try {
            setDetailLoading(importId);
            const res = await axios.post(`${PURCHASE_API}/physical-inventory/variance/detail`, { importId });
            setDetail(res.data.data);
            setSelected([]);
        } catch (err) {
            showToast(err.response?.data?.message || "Failed to load the physical inventory", "error");
        } finally {
            setDetailLoading(null);
        }
    };

    const closeDetail = () => {
        if (applying) return;
        setDetail(null);
        setSelected([]);
    };

    const pendingIds = detail ? detail.rows.filter((r) => r.applyStatus === "PENDING").map((r) => r.id) : [];
    const allSelected = pendingIds.length > 0 && pendingIds.every((id) => selected.includes(id));

    const toggleOne = (id) =>
        setSelected((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));

    const toggleAll = () => setSelected(allSelected ? [] : pendingIds);

    const handleApply = async () => {
        if (!detail || selected.length === 0 || applying) return;
        try {
            setApplying(true);
            const res = await axios.post(`${PURCHASE_API}/physical-inventory/variance/apply`, {
                importId: detail.importId,
                ids: selected
            });
            const d = res.data.data;
            showToast(
                `${d.importId}: ${d.linesUpdated} batch(es) updated. ${d.stockRowsUpdated} stock row(s) updated, ${d.stockRowsInserted} new stock row(s) added.` +
                (d.pendingLeft ? ` ${d.pendingLeft} batch(es) still pending.` : ""),
                "success"
            );
            await openDetail(detail.importId); // refresh the modal (updated lines become read-only)
            fetchInventory();                  // refresh the list status
        } catch (err) {
            showToast(err.response?.data?.message || "Failed to update the selected batches", "error");
        } finally {
            setApplying(false);
        }
    };

    const anyProductMatches = (filterSet) =>
        products.some((p) => productMatchesFilterSet(p, filterSet, null));

    // Same rule as Product Master: Raw Material gets Category / Sub Category /
    // Quality Category; every other type (or none selected yet) gets the
    // cable-style attribute filters.
    const selectedType = (filters.productType?.value || "").trim().toLowerCase();
    const isRawMaterial = selectedType === "raw material";

    // Changing Product Type resets all type-specific filters (as Product Master does)
    const handleProductTypeChange = (opt) => {
        setFilters((prev) => ({
            ...prev,
            productType: opt,
            productCode: null,
            construction: null,
            code: null,
            cableType: null,
            category: null,
            noOfCores: null,
            color: null,
            nominalCrossSection: null,
            referenceOfStandard: null,
            voltage: null,
            subCategory: null,
            qualityCategory: null
        }));
    };

    const handleFilterChange = (key, opt) => {
        setFilters((prev) => {
            let updated = { ...prev, [key]: opt };
            if (!ATTRIBUTE_FILTER_KEYS.includes(key) || products.length === 0) return updated;

            const clearOrder = ATTRIBUTE_FILTER_KEYS.filter((k) => k !== key).reverse();
            let i = 0;
            while (i < clearOrder.length && !anyProductMatches(updated)) {
                updated = { ...updated, [clearOrder[i]]: null };
                i++;
            }

            return updated;
        });
    };

    // Keep the dd-mm-yyyy text boxes in sync whenever filters.dateFrom / dateTo
    // change from elsewhere (e.g. a "clear filters" action resetting them to "").
    useEffect(() => {
        setDateFromText(isoToDisplayDate(filters.dateFrom));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters.dateFrom]);

    useEffect(() => {
        setDateToText(isoToDisplayDate(filters.dateTo));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters.dateTo]);

    // The Posting Date filters are displayed as dd-mm-yyyy but stored/sent to
    // the backend as yyyy-mm-dd. This converts the stored ISO value to the
    // dd-mm-yyyy string shown in the text box.
    const isoToDisplayDate = (iso) => {
        if (!iso) return "";
        const [y, m, d] = iso.split("-");
        if (!y || !m || !d) return "";
        return `${d}-${m}-${y}`;
    };

    // Handles typing into a dd-mm-yyyy date filter box: auto-inserts the
    // dashes as the user types, and only commits a value to the filter
    // (as yyyy-mm-dd) once a complete, valid date has been entered.
    const handleDateDisplayChange = (e, filterKey, setText) => {
        const raw = e.target.value.replace(/[^0-9]/g, "").slice(0, 8); // ddmmyyyy digits only
        let formatted = raw;
        if (raw.length > 4) {
            formatted = `${raw.slice(0, 2)}-${raw.slice(2, 4)}-${raw.slice(4)}`;
        } else if (raw.length > 2) {
            formatted = `${raw.slice(0, 2)}-${raw.slice(2)}`;
        }
        setText(formatted);

        if (raw.length === 8) {
            const day = raw.slice(0, 2);
            const month = raw.slice(2, 4);
            const year = raw.slice(4, 8);
            const iso = `${year}-${month}-${day}`;
            const d = new Date(iso);
            if (!Number.isNaN(d.getTime()) && d.getFullYear() === Number(year)) {
                setFilters((prev) => ({ ...prev, [filterKey]: iso }));
            }
        } else if (raw.length === 0) {
            setFilters((prev) => ({ ...prev, [filterKey]: "" }));
        }
    };

    // yyyy-mm-dd (local) of a posting timestamp, for the From/To range check
    const toLocalIso = (value) => {
        const d = new Date(value);
        if (Number.isNaN(d.getTime())) return "";
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
    };

    // Posting Date From / To (inclusive) applied on the list
    const activeData = tableData.filter((row) => {
        if (!filters.dateFrom && !filters.dateTo) return true;
        const iso = toLocalIso(row.created_at);
        if (!iso) return false;
        if (filters.dateFrom && iso < filters.dateFrom) return false;
        if (filters.dateTo && iso > filters.dateTo) return false;
        return true;
    });


    const totalPages = Math.max(1, Math.ceil(activeData.length / pageSize));
    const paginatedData = activeData.slice(
        (currentPage - 1) * pageSize,
        currentPage * pageSize
    );

    const goToPrevPage = () => {
        setCurrentPage((prev) => Math.max(1, prev - 1));
    };

    const goToNextPage = () => {
        setCurrentPage((prev) => Math.min(totalPages, prev + 1));
    };

    const handlePageSizeChange = (e) => {
        setPageSize(Number(e.target.value));
        setCurrentPage(1);
    };

    return (
        <Layout>
            {toast && (
                <div
                    role="status"
                    style={{
                        position: "fixed", top: "20px", right: "20px", zIndex: 100000, display: "flex", alignItems: "flex-start", gap: "10px",
                        maxWidth: "460px", padding: "12px 14px", borderRadius: "8px",
                        borderLeft: `4px solid ${TOAST_COLORS[toast.type].border}`,
                        background: TOAST_COLORS[toast.type].bg, color: TOAST_COLORS[toast.type].text,
                        boxShadow: "0 8px 24px rgba(15, 23, 42, 0.18)", fontSize: "14px"
                    }}
                >
                    <span style={{ fontWeight: 700 }}>{TOAST_COLORS[toast.type].icon}</span>
                    <span style={{ flex: 1 }}>{toast.message}</span>
                    <button type="button" onClick={() => setToast(null)} aria-label="Close"
                        style={{ background: "none", border: "none", cursor: "pointer", color: "inherit", fontSize: "16px", lineHeight: 1 }}>×</button>
                </div>
            )}
            <div className="container-fluid p-4">

                <div style={styles.pageTitleBar}>
                    <h2 style={styles.pageTitle}>
                        Variance Posting
                    </h2>

                    <p style={styles.pageSubtitle}>
                        Physical inventory counts and their variance (increase / decrease)
                    </p>
                </div>

                <div style={styles.filterCard}>

                    {/* Row 1: Product Type */}
                    <div className="row mb-3">
                        <div className="col-md-3">
                            <label style={styles.compactLabel}>Product Type</label>
                            <Select
                                styles={selectStyles}
                                placeholder="Select Product Type"
                                options={productTypes}
                                value={filters.productType}
                                onChange={handleProductTypeChange}
                                isClearable
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                            />
                        </div>
                    </div>

                    {/* Row 2: type-specific attribute filters (change with Product Type, like Product Master) */}
                    <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "flex-end", marginBottom: 15 }}>
                        {(isRawMaterial
                            ? [
                                { key: "category", label: "Category" },
                                { key: "subCategory", label: "Sub Category" },
                                { key: "qualityCategory", label: "Quality Category" },
                            ]
                            : [
                                { key: "construction", label: "Construction" },
                                { key: "code", label: "Code" },
                                { key: "cableType", label: "Cable Type" },
                                { key: "category", label: "Category" },
                                { key: "noOfCores", label: "Cores" },
                                { key: "color", label: "Color" },
                                { key: "nominalCrossSection", label: "Cross Section" },
                                { key: "referenceOfStandard", label: "Std. Ref" },
                                { key: "voltage", label: "Voltage" },
                            ]
                        ).map(({ key, label }) => (
                            <div key={key} style={{ flex: "1 1 0", minWidth: 100 }}>
                                <label style={styles.compactLabel}>{label}</label>
                                <Select
                                    placeholder={label}
                                    isClearable
                                    options={getCascadingOptions(key)}
                                    value={filters[key]}
                                    onChange={(opt) => handleFilterChange(key, opt)}
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    styles={cableFilterSelectStyles}
                                />
                            </div>
                        ))}
                    </div>

                    {/* Row 3: Product Code, Batch Number, Storage Location */}
                    <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "flex-end" }}>
                        <div style={{ flex: "1 1 0", minWidth: 150 }}>
                            <label style={styles.compactLabel}>Product Code</label>
                            <Select
                                placeholder="Select..."
                                options={cascadingProductCodeOptions}
                                value={filters.productCode}
                                onChange={(val) => handleFilterChange("productCode", val)}
                                isClearable
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                styles={cableFilterSelectStyles}
                            />
                        </div>

                        <div style={{ flex: "1 1 0", minWidth: 150 }}>
                            <label style={styles.compactLabel}>Batch Number</label>
                            <Select
                                placeholder="Select..."
                                options={batchNumberOptions}
                                value={filters.batchNumber}
                                onChange={(val) => handleFilterChange("batchNumber", val)}
                                isClearable
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                styles={cableFilterSelectStyles}
                            />
                        </div>

                        <div style={{ flex: "1 1 0", minWidth: 150 }}>
                            <label style={styles.compactLabel}>Storage Location</label>
                            <Select
                                placeholder="Select..."
                                options={storageLocationOptions}
                                value={filters.storageLocation}
                                onChange={(val) => handleFilterChange("storageLocation", val)}
                                isClearable
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                styles={cableFilterSelectStyles}
                            />
                        </div>

                        <div style={{ flex: "1 1 0", minWidth: 150 }}>
                            <label style={styles.compactLabel}>Posting Date From</label>
                            <input
                                type="text"
                                placeholder="dd-mm-yyyy"
                                value={dateFromText}
                                onChange={(e) => handleDateDisplayChange(e, "dateFrom", setDateFromText)}
                                maxLength={10}
                                style={styles.dateInput}
                            />
                        </div>

                        <div style={{ flex: "1 1 0", minWidth: 150 }}>
                            <label style={styles.compactLabel}>Posting Date To</label>
                            <input
                                type="text"
                                placeholder="dd-mm-yyyy"
                                value={dateToText}
                                onChange={(e) => handleDateDisplayChange(e, "dateTo", setDateToText)}
                                maxLength={10}
                                style={styles.dateInput}
                            />
                        </div>
                    </div>

                </div>

                <div style={styles.tableContainer}>
                    <div className="table-responsive">
                        <table className="table" style={styles.erpTable}>
                            <thead>
                                <tr>
                                    <th style={styles.erpTh}>Physical Inventory ID</th>
                                    <th style={styles.erpTh}>Posting Date</th>
                                    <th style={styles.erpTh}>Posted By</th>
                                    <th style={styles.erpTh}>Status</th>
                                    <th style={{ ...styles.erpTh, textAlign: "center" }}>View</th>
                                </tr>
                            </thead>

                            <tbody>
                                {paginatedData.length === 0 ? (
                                    <tr>
                                        <td colSpan="5" className="text-center">
                                            No Records Found
                                        </td>
                                    </tr>
                                ) : (
                                    paginatedData.map((row) => {
                                        const chip = STATUS_CHIP[row.apply_status] || STATUS_CHIP.PENDING;
                                        return (
                                            <tr key={row.import_id}>
                                                <td style={{ ...styles.erpTd, fontWeight: 600 }}>{row.import_id}</td>
                                                <td style={styles.erpTd}>{formatDate(row.created_at)}</td>
                                                <td style={styles.erpTd}>{row.imported_by || "-"}</td>
                                                <td style={styles.erpTd}>
                                                    <span
                                                        title={row.pending_lines > 0 && row.total_lines ? `${row.pending_lines} of ${row.total_lines} batch(es) pending` : undefined}
                                                        style={{ background: chip.bg, color: chip.color, borderRadius: 999, padding: "3px 10px", fontSize: 12, fontWeight: 600 }}
                                                    >
                                                        {chip.label}
                                                    </span>
                                                </td>
                                                <td style={{ ...styles.erpTd, textAlign: "center" }}>
                                                    <button
                                                        onClick={() => openDetail(row.import_id)}
                                                        disabled={detailLoading === row.import_id}
                                                        title="View batches / post stock"
                                                        style={{ border: "1px solid #e2e8f0", background: "#fff", borderRadius: 6, padding: "4px 14px", height: 28, cursor: detailLoading === row.import_id ? "wait" : "pointer", fontSize: 12, fontWeight: 600, color: "#2563eb", lineHeight: 1 }}
                                                    >
                                                        {detailLoading === row.import_id ? "Loading…" : "View"}
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div style={styles.paginationBar}>
                    <div style={styles.paginationInfo}>
                        Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong> • Total {activeData.length}
                    </div>

                    <div style={styles.paginationButtons}>
                        <button
                            onClick={goToPrevPage}
                            disabled={currentPage === 1}
                            style={currentPage === 1 ? styles.paginationBtnDisabled : styles.paginationBtn}
                        >
                            Prev
                        </button>

                        <button
                            onClick={goToNextPage}
                            disabled={currentPage === totalPages}
                            style={currentPage === totalPages ? styles.paginationBtnDisabled : styles.paginationBtn}
                        >
                            Next
                        </button>

                        <select
                            value={pageSize}
                            onChange={handlePageSizeChange}
                            style={styles.pageSizeSelect}
                        >
                            {PAGE_SIZE_OPTIONS.map((size) => (
                                <option key={size} value={size}>
                                    {size} / page
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

            </div>


            {detail && (
                <div style={modalStyles.overlay}>
                    <div style={modalStyles.modal}>
                        <div style={modalStyles.header}>
                            <h4 style={{ margin: 0, fontSize: 18, fontWeight: 600, color: "#0f172a" }}>
                                Physical Inventory {detail.importId}
                            </h4>
                            <div style={{ fontSize: 12, color: "#64748b", marginTop: 2 }}>
                                Posted on {formatDate(detail.createdAt)}{detail.importedBy ? ` by ${detail.importedBy}` : ""}
                            </div>
                        </div>

                        <div style={modalStyles.summary}>
                            <span style={modalStyles.chip}>Total batches: {detail.summary.totalRows}</span>
                            <span style={{ ...modalStyles.chip, background: "#fef3c7", color: "#92400e" }}>Pending: {detail.summary.pendingRows}</span>
                            <span style={{ ...modalStyles.chip, background: "#dcfce7", color: "#166534" }}>Posted: {detail.summary.updatedRows}</span>
                            <span style={{ ...modalStyles.chip, background: "#dcfce7", color: "#166534" }}>Increase: +{formatQty(detail.summary.totalIncrease)}</span>
                            <span style={{ ...modalStyles.chip, background: "#fee2e2", color: "#b91c1c" }}>Decrease: {formatQty(detail.summary.totalDecrease)}</span>
                        </div>

                        <div style={modalStyles.body}>
                            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                <thead>
                                    <tr>
                                        <th style={{ ...modalStyles.th, width: 36 }}>
                                            <input
                                                type="checkbox"
                                                checked={allSelected}
                                                onChange={toggleAll}
                                                disabled={pendingIds.length === 0 || applying}
                                                title="Select all pending batches"
                                            />
                                        </th>
                                        {["S.No", "Product Type", "Batch Number", "Product Code", "Description", "UOM", "System Qty", "Actual Qty", "Variance", "Unit Price", "Total Price", "Currency", "Storage Code", "Storage Location", "Status"].map((h) => (
                                            <th key={h} style={{ ...modalStyles.th, textAlign: "left" }}>{h}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {detail.rows.map((r, idx) => {
                                        const pending = r.applyStatus === "PENDING";
                                        const tone = varianceTone(r.variance);
                                        return (
                                            <tr key={r.id} style={{ background: !pending ? "#f8fafc" : selected.includes(r.id) ? "#fffbeb" : "#fff" }}>
                                                <td style={modalStyles.td}>
                                                    <input
                                                        type="checkbox"
                                                        checked={pending && selected.includes(r.id)}
                                                        onChange={() => toggleOne(r.id)}
                                                        disabled={!pending || applying}
                                                    />
                                                </td>
                                                <td style={modalStyles.td}>{idx + 1}</td>
                                                <td style={modalStyles.td}>{r.productType || "-"}</td>
                                                <td style={modalStyles.td}>{r.batchNumber}</td>
                                                <td style={modalStyles.td}>{r.productCode}</td>
                                                <td style={modalStyles.td}>{r.description || "-"}</td>
                                                <td style={modalStyles.td}>{r.uom || "-"}</td>
                                                <td style={modalStyles.td}>{r.oldQty === null ? "-" : formatQty(r.oldQty)}</td>
                                                <td style={{ ...modalStyles.td, fontWeight: 600, color: tone.color, background: tone.bg }}>{r.actualQty === null ? "-" : formatQty(r.actualQty)}</td>
                                                <td style={{ ...modalStyles.td, fontWeight: 600, color: tone.color, background: tone.bg }}>
                                                    {r.variance > 0 ? "+" : ""}{r.variance === 0 ? "-" : formatQty(r.variance)}
                                                </td>
                                                <td style={{ ...modalStyles.td, textAlign: "right" }}>{formatAmount(r.unitPrice)}</td>
                                                <td style={{ ...modalStyles.td, textAlign: "right" }}>{formatAmount(r.totalPrice)}</td>
                                                <td style={modalStyles.td}>{r.currency || "-"}</td>
                                                <td style={modalStyles.td}>{renderChange(r.oldStorageCode, r.newStorageCode)}</td>
                                                <td style={modalStyles.td}>{renderChange(r.oldStorageLocation, r.newStorageLocation)}</td>
                                                <td style={modalStyles.td}>
                                                    {pending ? (
                                                        <span style={{ color: "#92400e", fontWeight: 600 }}>
                                                            {r.isNew ? `Pending - new stock${r.newStatus ? ` (${r.newStatus})` : ""}` : "Pending"}
                                                        </span>
                                                    ) : (
                                                        <span style={{ color: "#166534", fontWeight: 600 }}>Posted{r.appliedAt ? ` on ${formatDate(r.appliedAt)}` : ""}</span>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>

                        <div style={modalStyles.footer}>
                            <div style={{ fontSize: 12, color: "#64748b" }}>
                                {pendingIds.length === 0
                                    ? "All batches of this physical inventory are already updated."
                                    : `${selected.length} of ${pendingIds.length} pending batch(es) selected. Confirming updates Stock, Stock Master, Planning Pegging Lock, Pegging and Actual Product Costing (new stock only) for the selected batches.`}
                            </div>
                            <div style={{ display: "flex", gap: 10 }}>
                                <button onClick={closeDetail} disabled={applying} style={styles.paginationBtn}>
                                    Close
                                </button>
                                <button
                                    onClick={handleApply}
                                    disabled={selected.length === 0 || applying}
                                    style={selected.length === 0 || applying ? styles.exportBtnDisabled : styles.exportBtn}
                                >
                                    {applying ? "Updating..." : `Confirm & Update${selected.length ? ` (${selected.length})` : ""}`}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </Layout>
    );
};

export default Variance;